import {clientDashboardView, ClientDashboardView} from "./view/ClientDashboardViewComponent";
import {clientDashboardDesktop, ClientDashboardDesktop} from "./desktop/ClientDashboardDesktopComponent";
import {clientDashboardTablet, ClientDashboardTablet} from "./tablet/ClientDashboardTabletComponent";
import {clientDashboardMobile, ClientDashboardMobile} from "./mobile/ClientDashboardMobileComponent";

import Components from "./components";
import {ClientDashboardService} from "./service/ClientDashboardService";
import {IInvestClientDashboardModelProvider} from "./service/iinvest/IInvestClientDashboardModelProvider";
import {IVClientDashboardModelProvider} from "./service/iv/IVClientDashboardModelProvider";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/client`;

    return angular.module("tfApp.dashboard.client", [Components(rootDir)])
                  .component(ClientDashboardView, clientDashboardView())
                  .component(ClientDashboardDesktop, clientDashboardDesktop(rootDir))
                  .component(ClientDashboardTablet, clientDashboardTablet(rootDir))
                  .component(ClientDashboardMobile, clientDashboardMobile(rootDir))
                  .service(IVClientDashboardModelProvider.id, IVClientDashboardModelProvider)
                  .service(IInvestClientDashboardModelProvider.id, IInvestClientDashboardModelProvider)
                  .service(ClientDashboardService.id, ClientDashboardService)
                  .name;
}
